import { html, ViewTemplate, ref } from '@microsoft/fast-element';
import type { ReducedFileUpload } from './reduced-file-upload';

export const ReducedFileUploadTemplate: ViewTemplate<ReducedFileUpload> = html`
  <div class="upload-new-file" ${ref('dropArea')}>
    <zero-button slot="buttons" class="upload-button" @click=${(x) => x.fileClick()}>
      Upload New File
    </zero-button>
  </div>
`;
